import { Button, Calendar, Select, Popover } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { DATE_FORMAT } from "../../Utils/date_utils";
import moment from "moment";
import { RestAvatar } from "../../Components/Avatars/RestAvatar";
import { TravelAvatar } from "../../Components/Avatars/TravelAvatar";
import { LiftAvatar } from "../../Components/Avatars/LiftAvatar";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { saveRestTravelDates } from "../../store/actions/team.actions";
import infoImage from "../../Images/info-icon.svg";
import "../../Styles/styles-RestTravelDays.css";
import { 
  PermissionedButton, 
  PermissionedSelect, 
  PermissionOverlay
} from "../PermissionedComponents";

const { Option } = Select;
const weekdays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const RestDays = () => {
  const ICON_COMBINATIONS = [1, 2, 4, 3, 5, 6, 7, 0];
  const dispatch = useDispatch();
  const {
    info: { restAndTravel },
    misc: {
      user_permissions: userPermissions
    },
  } = useSelector(({ team }) => team);
  const [restWeekDays, setRestWeekDays] = useState([]);
  const [days, setDays] = useState({});
  const [panel, setPanel] = useState(new moment());
  const panelChange = useRef(false);

  // Check if user has permission to modify rest and travel days
  const canModifyRestAndTravel = userPermissions?.ManageCalendarTags

  const dateCellRender = (value) => {
    const daySatus = days[value.format(DATE_FORMAT)] || 0;
    const travel = (daySatus & 1) !== 0;
    const rest = (daySatus & 2) !== 0;
    const lift = (daySatus & 4) !== 0;
    const today = moment().format(DATE_FORMAT);
    return (
      <div style={{ padding: "0px 4px" }}>
        <div
          style={{
            height: 64,
            display: "flex",
            flexDirection: "column",
            gap: 4,
            borderTop: "2px solid #d9d9d9",
            backgroundColor:
              today == value.format(DATE_FORMAT) ? "#e6f4ff" : "#fff",
            cursor: canModifyRestAndTravel ? "pointer" : "default",
          }}
        >
          {value.get("date")}
          <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
            {travel && <TravelAvatar size="small" />}
            {rest && <RestAvatar size="small" />}
            {lift && <LiftAvatar size="small" />}
          </div>
        </div>
      </div>
    );
  };

  const onToggleDateCell = (date) => {
    // Check if user has permission to modify rest and travel days
    if (!canModifyRestAndTravel) {
      return;
    }

    if (panelChange.current) {
      panelChange.current = false;
      return;
    }
    const dateString = date.format(DATE_FORMAT);
    const daySatus = days[dateString] || 0;

    const currentIndex = ICON_COMBINATIONS.indexOf(daySatus);
    const nextIndex = (currentIndex + 1) % ICON_COMBINATIONS.length;
    const nextStatus = ICON_COMBINATIONS[nextIndex];

    setDays({
      ...days,
      [dateString]: nextStatus,
    });
  };

  const changeRestWeekly = (weekDay, mode, year = false) => {
    let firstWeekday = year ? moment() : panel.clone().startOf("month");
    for (
      ;
      firstWeekday.day() !== +weekDay;
      firstWeekday = firstWeekday.add(1, "day")
    );
    let lastWeekday = firstWeekday.clone();
    if (year) lastWeekday = lastWeekday.add(51, "weeks");
    else {
      for (
        ;
        lastWeekday.month() === firstWeekday.month();
        lastWeekday = lastWeekday.add(1, "week")
      );
      lastWeekday.add(-1, "week");
    }
    let newDays = days;
    if (mode === 1) {
      for (
        let date = firstWeekday;
        date <= lastWeekday;
        date = date.add(1, "week")
      ) {
        const dateString = date.format(DATE_FORMAT);
        const dayStatus = newDays[dateString] || 0;
        newDays[dateString] = dayStatus >= 2 ? dayStatus : dayStatus + 2;
      }
    } else {
      Object.keys(newDays).forEach((date) => {
        if (moment(date).day() === +weekDay)
          newDays[date] =
            newDays[date] >= 2 ? newDays[date] - 2 : newDays[date];
      });
    }
    setDays(newDays);
  };

  const selectRestWeekDay = (mode) => (value) => {
    if (mode === 0) {
      // deselect weekday
      setRestWeekDays(restWeekDays.filter((v) => +v !== +value));
    } else {
      // select weekday
      setRestWeekDays([...restWeekDays, value]);
    }
    changeRestWeekly(value, mode, true);
  };

  const handlePanelChange = (value) => {
    panelChange.current = true;
    setPanel(value);
  };

  useEffect(() => {
    setDays(restAndTravel);
  }, [restAndTravel]);

  const handleSave = async () => {
    const restDays = [];
    const travelDays = [];
    const liftDays = [];
    Object.keys(days).forEach((date) => {
      if (days[date] & 2) restDays.push(date);
      if (days[date] & 1) travelDays.push(date);
      if (days[date] & 4) liftDays.push(date);
    });
    dispatch(
      saveRestTravelDates({ rest_dates: restDays, travel_dates: travelDays, lift_dates: liftDays })
    );
  };

  useEffect(() => {
    restWeekDays.forEach((weekDay) => {
      changeRestWeekly(weekDay, 1);
    });
  }, [panel]);

  return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 24,
          padding: "24px 0px",
        }}
      >
        <div className="rest-weekdays" style={{ fontSize: 16, display: "flex" }}>
          Set all{" "}
          <PermissionedSelect
            permissionCheck="ManageCalendarTags"
            value={restWeekDays}
            mode="multiple"
            onSelect={selectRestWeekDay(1)}
            onDeselect={selectRestWeekDay(0)}
            showSearch
            style={{ minWidth: 150, margin: "0px 8px" }}
            filterOption={(input, option) =>
              String(option?.children ?? '').toLowerCase().includes(input.toLowerCase())
            }
          >
            {weekdays.map((weekday, value) => (
              <Option key={value} value={value.toString()}>{weekday}s</Option>
            ))}
          </PermissionedSelect>{" "}
          as rest days.
          <Popover
            placement="rightTop"
            content={
              <>
                <span>
                  Only applies to days in the future.
                  <br />
                  To edit days in the past, please select specific dates on the
                  calendar.
                </span>
              </>
            }
          >
            <img src={infoImage} alt="info-img" />
          </Popover>
          <div
            style={{
              display: "flex",
              gap: 8,
              alignItems: "center",
              fontSize: 12,
              margin: "0px 16px 0px 32px",
            }}
          >
            <TravelAvatar size={25} />
            <div>Travel Day</div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <div
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                fontSize: 12,
              }}
            >
              <RestAvatar size={25} />
              <div>Rest Day</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 16,  margin: "0px 16px 0px 16px" }}>
            <div
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                fontSize: 12,
              }}
            >
              <LiftAvatar size={25} />
              <div>Lift Day</div>
            </div>
          </div>
        </div>
        <p>Click a date to mark it as Rest, Travel, Lift — or a combination of all three.</p>
        <PermissionOverlay
        permissionCheck="ManageCalendarTags"
        tooltipMessage="You don't have permission to manage calendar tags">
        <Calendar
          mode="month"
          style={{ width: 660, borderBottom: "1px solid #f0f0f0" }}
          dateFullCellRender={dateCellRender}
          onSelect={onToggleDateCell}
          onPanelChange={handlePanelChange}
          fullscreen={false}
        />
        </PermissionOverlay>
        <div>
          <PermissionedButton 
            onClick={handleSave} 
            type="primary"
            permissionCheck="ManageCalendarTags"
          >
            Save Setting
          </PermissionedButton>
        </div>
      </div>
  );
};
